
import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';
import {
	endpointsMap,
	IFindAvailableStoresOptions,
	IFindAvailableStoresResponse,
	ICreateReservationOptions,
	ICreateReservationResponse
} from './ICustomShopperReservations';

/**
 * Represents CustomShopperReservations
 */
class CustomShopperReservations extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Gets the categories result for the given query
	 * @param {ICreateReservationOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ICreateReservationResponse} - Array of categories
	 */
	public async createReservation(
		fetchOptions: ICreateReservationOptions,
		throwOnError?: boolean
	): Promise<ICreateReservationResponse> {
		const response: ICreateReservationResponse = await this.callCustomEndpoint<ICreateReservationResponse>(
			fetchOptions,
			endpointsMap.CREATE_RESERVATION
		);

		if (throwOnError && !response.confirmMessage) {
			throw new Error('Reservation creation failed.');
		}

		return response;
	}

	/**
	 * Gets the categories result for the given query
	 * @param {IFindAvailableStoresOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IFindAvailableStoresResponse} - Array of categories
	 */
	public async findAvailableStores(
		fetchOptions: IFindAvailableStoresOptions,
		throwOnError?: boolean
	): Promise<IFindAvailableStoresResponse> {
		const response: IFindAvailableStoresResponse = await this.callCustomEndpoint<IFindAvailableStoresResponse>(
			fetchOptions,
			endpointsMap.GET_RESERVATIONS_STORE
		);

		if (throwOnError && !response.stores) {
			throw new Error('No stores found.');
		}

		return response;
	}
}

export default CustomShopperReservations;
